<template>
  <div>
    <div class="d-flex justify-content-end mb-3">
      <ai-template-blinking-animation v-if="aiTemplateLoader" />
    </div>
    <el-row :gutter="20" class="d-flex flex-wrap">
      <el-col :md="12" class="mb-2">
        <add-new-card
          horizontal
          :disabled="disabled"
          :title="title"
          :min-height="minHeight"
          @click="onClick"
        />
      </el-col>
      <el-col
        v-if="$breakpoint.mdAndUp"
        :md="12"
        class="mb-2"
      >
        <ib-list-view-placeholder-card :disabled="disabled" />
      </el-col>
      <el-col
        v-if="$breakpoint.mdAndUp"
        :md="12"
        class="mb-2"
      >
        <ib-list-view-placeholder-card :disabled="disabled" />
      </el-col>
      <el-col
        v-if="$breakpoint.mdAndUp"
        :md="12"
        class="mb-2"
      >
        <ib-list-view-placeholder-card
          variant="yellow"
          :disabled="disabled"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AddNewCard from '@/components/_v2/AddNewCard.vue'
import AiTemplateBlinkingAnimation from '@/views/Home/StoryMode/Components/AiTemplateBlinkingAnimation.vue'
import MixinAiTemplate from '@/mixins/aiTemplate'

export default {
  name: 'IbListViewPlaceholder',

  components: { AiTemplateBlinkingAnimation, AddNewCard },

  mixins: [MixinAiTemplate],

  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: String,
      default: '58px'
    }
  },

  methods: {
    onClick () {
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>
